import React from 'react';
import styled from 'styled-components';
import { useStepRegister } from 'context/login/StepRegister';
import Icon from 'components/_UI/Icon';
import breakpoints from 'theme/breakpoints';
import colors from 'theme/colors';
import FastOnboarding from './FastOnboarding';
import OnboardingTags from './OnboardingTags';
import { accent } from '../common/AuthForm';

const STEP_REGISTER_ONE = 1
const STEP_REGISTER_TWO = 2
const TOTAL_STEPS = 2

function SignUp() {
    const { stepRegister } = useStepRegister();

    return (
        <Container>
            <BoxContainer>
                <LogoContainer>
                    <Icon name='whizr-inline-logo-dark' />
                </LogoContainer>

                <StepIndicator aria-label={`Passo ${stepRegister} de ${TOTAL_STEPS}`}>
                    {Array.from({ length: TOTAL_STEPS }, (_, index) => (
                        <StepBar key={index} $active={index < stepRegister} />
                    ))}
                </StepIndicator>

                {stepRegister === STEP_REGISTER_ONE && <FastOnboarding />}
                {stepRegister === STEP_REGISTER_TWO && <OnboardingTags />}
            </BoxContainer>
        </Container>
    )
};

/* Mesma coluna da /entrar: 441px, centralizada no painel. */
const Container = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    min-height: 100vh;
    padding-top: 40px;

    @media screen and (min-width: ${breakpoints.lg}) {
        min-height: 100%;
        padding: 56px 0 40px;
    }
`;

const BoxContainer = styled.div`
    display: flex;
    align-items: center;
    flex-direction: column;
    width: 100%;
    max-width: 489px;
    padding: 8px 24px 32px;

    & > * {
        flex-shrink: 0;
    }

    @media screen and (min-width: ${breakpoints.lg}) {
        width: 441px;
        max-width: none;
        padding: 0;
    }
`;

const LogoContainer = styled.div`
    --home-logo-color: ${colors.homeAccent};
    width: 144px;
    height: 40px;
`;

const StepIndicator = styled.div`
    display: flex;
    gap: 6px;
    margin: 22px 0 20px;
`;

const StepBar = styled.span`
    width: 28px;
    height: 4px;
    border-radius: 2px;
    background: ${({ $active }) => $active ? accent : '#E2DDF6'};
    transition: background .3s ease;
`;

export default SignUp;
